import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClientNotesRoutingModule } from './client-notes-routing.module';
import { ClientNotesComponent } from '../client-notes/client-notes.component';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { MaskedTextBoxModule, NumericTextBoxAllModule, NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { NgSelectModule } from '@ng-select/ng-select';
import { MyDatePickerModule } from 'mydatepicker';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { ClientNotesService } from './client-notes.service';
import { ClientNotesDateService } from './client-nottes-service';

@NgModule({
  declarations: [ClientNotesComponent],
  imports: [
    CommonModule,
    FormsModule,
    GridModule,
    ReactiveFormsModule,
    MultiselectDropdownModule,
    NumericTextBoxModule,
    NumericTextBoxAllModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    NgSelectModule,
    ClientNotesRoutingModule,
    MyDatePickerModule,
    PDFExportModule
  ],
  exports:[ClientNotesComponent],
  
  providers:[ClientNotesService,ClientNotesDateService ]
})
export class ClientNotesModule { }
